import React, { Component } from "react";
import PropTypes from "prop-types";
import { TransitionGroup, CSSTransition } from "react-transition-group";

class TransitionRouter extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
        location: PropTypes.object,
        className: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.string)
        ]),
        onLocationChange: PropTypes.func
    };

    componentDidUpdate(prevProps) {
        const { location, onLocationChange } = this.props;

        if (prevProps.location !== location) {
            if (onLocationChange) {
                onLocationChange(
                    prevProps.location.pathname,
                    location.pathname
                );
            }
        }
    }

    render() {
        const { children, location, className, ...rest } = this.props;

        return (
            <TransitionGroup className={className}>
                <CSSTransition key={location.pathname} {...rest}>
                    {state => children(state)}
                </CSSTransition>
            </TransitionGroup>
        );
    }
}

export default TransitionRouter;



// WEBPACK FOOTER //
// ./src/scripts/components/TransitionRouter.js